<template>
  <div class="container">
    <div class="left-container" v-if="video">
      <div class="title-bar">
        <span class="video-type">
          <i
            class="icon icon-live-stream-red"
            :class="
              video.type === 'stream'
                ? 'icon-live-stream-red'
                : 'icon-video-red'
            "
          ></i
          >{{ getDict(video.type === "stream" ? 1 : 9) }}
        </span>
        <span class="video-title">{{ video.title }}</span>
        <span class="watch-num">
          <i class="icon icon-watch-people"></i
          >{{ video.viewCount | readableNum }}
        </span>
        <span class="user-info">
          <span
            v-if="video.streamerAvatar"
            class="user-avatar"
            :style="{
              backgroundImage: video.streamerAvatar
                ? `url(${video.streamerAvatar})`
                : 'none',
            }"
          ></span
          ><span class="user-name">{{ video.streamer }}</span>
          <!-- <i class="icon icon-follow" :class="[video.followed && 'active']"></i> -->
        </span>
        <span class="enter-live-stream" @click="goVideo(video.videoId)">{{
          getDict(6)
        }}</span>
      </div>
      <player
        class="video-player"
        :platform="video.platform"
        :video-id="video.videoId"
      />
    </div>
    <div class="right-container">
      <tabBar
        :activeID.sync="activeTab"
        :tabList="[
          { name: getDict(7), id: 'tornament' },
          { name: getDict(8), id: 'liveBroadcast' },
        ]"
      ></tabBar>
      <ul class="video-list">
        <li
          v-for="(v, index) in videoList"
          class="video-container"
          @click="activeVideoIndex = index"
          :key="index"
        >
          <div
            class="video-thumbnail-wrapper"
            :class="{ active: index === activeVideoIndex }"
            :style="{ backgroundImage: `url(${v.thumbnailMedium})` }"
          >
            <div class="video-info">
              <div class="user-info">
                <span
                  class="user-avatar"
                  :style="{
                    backgroundImage: v.streamerAvatar
                      ? `url(${v.streamerAvatar})`
                      : 'none',
                  }"
                ></span
                ><span class="user-name">{{ v.streamer }}</span>
              </div>
              <div class="watch-num">
                <i class="icon icon-watch-people-yellow"></i
                >{{ v.viewCount | readableNum }}
              </div>
            </div>
          </div>
          <h3 class="video-title">{{ v.title }}</h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getDict, getPageLevelMixin, webSocket } from "../common";
import Player from "../components/player";
import TabBar from "../components/tabBar";
import { mapState, mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "liveCenter",
  mixins: [getPageLevelMixin],
  data() {
    return {
      pageLevel: 1,
      /*video: {
          title: '直播直播直播名称直播直播直播名称直播直播直播名称',
          watchNum: 115000,
          type: 'stream',
          user: '無雙無雙無雙無雙無雙無雙~',
          userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
          followed: false,
          platform: 'youtube',
          id: 'NJnG8ZOnH4E',
          thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
        },*/
      activeTab: "tornament",
      activeVideoIndex: 0,
      /*videoList: [{
          title: '直播直播直播名称直播直播直播名称直播直播直播名称',
          watchNum: 115000,
          type: 'stream',
          user: '無雙無雙無雙無雙無雙無雙~',
          userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
          followed: false,
          platform: 'youtube',
          id: 'NJnG8ZOnH4E',
          thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
        },{
          title: '直播直播直播名称直播直播直播名称直播直播直播名称',
          watchNum: 115000,
          type: 'stream',
          user: '無雙無雙無雙無雙無雙無雙~',
          userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
          followed: false,
          platform: 'youtube',
          id: 'NJnG8ZOnH4E',
          thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
        },{
          title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
          watchNum: 115000,
          type: 'stream',
          user: '無雙無雙無雙無雙無雙無雙~',
          userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
          followed: false,
          platform: 'youtube',
          id: 'NJnG8ZOnH4E',
          thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
        },]*/
    };
  },
  watch: {
    activeTab() {
      this.activeVideoIndex = 0;
    },
    video() {
      this.changeVideo(this.video, false);
    },
  },
  computed: {
    ...mapState(["_liveCenterObj"]),
    videoList() {
      switch (this.activeTab) {
        case "tornament":
          return this._liveCenterObj.tornamentList;
          break;
        case "liveBroadcast":
          return this._liveCenterObj.liveBroadcastList;
          break;
      }
      return [];
    },
    video() {
      if (this.videoList[this.activeVideoIndex]) {
        return {
          ...this.videoList[this.activeVideoIndex],
          type: ["live", "upComing", "upcoming"].includes(
            this.videoList[this.activeVideoIndex].liveBroadcastContent
          )
            ? "stream"
            : "video",
        };
      } else {
        return {};
      }
    },
  },
  methods: {
    getDict,
    goVideo(id) {
      switch (this.activeTab) {
        case "tornament":
          this.$router.push(`/tornament/${id}`);
          break;
        case "liveBroadcast":
          this.$router.push(`/liveBroadcast/${id}`);
          break;
      }
    },
    async changeVideo(video, leave) {
      if (video && video.videoId) {
        await webSocket.get("/live/watch", {
          room_id: video.videoId,
          leave,
          live: ["live", "upComing", "upcoming"].includes(
            video.liveBroadcastContent
          ),
        });
      }
    },
  },
  components: {
    Player,
    TabBar,
  },
  created() {
    store.dispatch("getTornamentList");
    store.dispatch("getLiveBroadcastList");
    this.changeVideo(this.video, false);
  },
  beforeDestroy() {
    this.changeVideo(this.video, true);
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 0.3rem;
  display: flex;
  flex: 1;
  justify-content: center;
  min-height: 0px;
  align-items: center;
}
.left-container {
  width: 9.6rem;
  margin-right: 0.2rem;
  /*display: flex;*/
  /*flex-direction: column;*/
}
$title-bar-height: 0.56rem;
.title-bar {
  height: $title-bar-height;
  padding: 0 0.12rem;
  line-height: 0.36rem;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  position: relative;
  .video-type {
    color: #c90e0e;
    font-size: 0.18rem;
    margin-right: 0.18rem;
  }
  .video-title {
    color: #232324;
    font-size: 0.22rem;
    max-width: 1.75rem;
    // max-width: 4.5rem;
    margin-right: 0.12rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .watch-num {
    color: white;
    font-size: 0.22rem;
    padding-right: 0.13rem;
    margin-right: 0.13rem;
    position: relative;
    &:after {
      content: " ";
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -0.115rem;
      width: 1px;
      height: 0.23rem;
      background: white;
    }
  }
  .user-info {
    color: white;
    font-size: 0.22rem;
    display: flex;
    align-items: center;
    .user-avatar {
      display: inline-block;
      background: no-repeat center center;
      background-size: 100% 100%;
      width: 0.38rem;
      height: 0.38rem;
      border-radius: 50%;
      margin-right: 0.04rem;
      border: 0.01rem solid #ecbc5f;
    }
    .user-name {
      max-width: 1.2rem;
      // max-width: 4rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .enter-live-stream {
    height: 0.36rem;
    line-height: 0.36rem;
    padding: 0 0.17rem;
    font-size: 0.2rem;
    color: #232324;
    background: url(../assets/enter-live-stream-btn.png) no-repeat center center;
    background-size: 100% 100%;
    position: absolute;
    right: 0.12rem;
    top: 50%;
    margin-top: -0.18rem;
    .lang-jp & {
      font-size: 0.13rem;
    }
    .lang-en & {
      font-size: 0.15rem;
    }
  }
}
$video-player-height: 5.4rem;
.video-player {
  height: $video-player-height;
}
.right-container {
  min-height: 0px;
  width: 2.8rem;
  height: $title-bar-height + $video-player-height;
  display: flex;
  flex-direction: column;
  .video-list {
    height: 100%;
    overflow: auto;
    .video-container {
      margin-bottom: 0.13rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .video-thumbnail-wrapper {
      width: 2.8rem;
      height: 1.42rem;
      background: rgba(255, 255, 255, 0.4) no-repeat center center;
      background-size: cover;
      position: relative;
      border: none;

      $active-border-width: 0.03rem;
      &.active {
        &:after {
          content: " ";
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          border: #{$active-border-width} solid #ffd559;
          box-sizing: border-box;
        }
      }
      .video-info {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        font-size: 0.14rem;
        height: 0.28rem + $active-border-width * 2;
        background: rgba(0, 0, 0, 0.7);
        color: #ffd559;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.18rem;
      }
      .user-info {
        .user-avatar {
          display: inline-block;
          background: no-repeat center center;
          background-size: 100% 100%;
          width: 0.24rem;
          height: 0.24rem;
          border-radius: 50%;
          margin-right: 0.04rem;
          border: 0.01rem solid #ecbc5f;
          vertical-align: -0.04rem;
        }
        .user-name {
          display: inline-block;
          max-width: 1.2rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
    .video-title {
      color: #232324;
      font-size: 0.18rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 0.03rem;
      line-height: 0.24rem;
    }
  }
}
</style>
